import React from 'react';
import { ErrorDisplay2 } from 'src/constrains/SalesChannelPreviewPageComponents/CollapseErrors';
import css from './css.module.less';
import { EnumModuleType } from 'src/types/common/module';
import { Field } from 'src/components/RcForm';
import { get } from 'lodash';
import {
  checkResponsiveContentCarousel,
  checkResponsiveProductGrid,
  checkResponsiveContentGrid,
  checkResponsiveProductCarousel,
  //   checkResponsiveText,
  //   checkResponsiveProductCarousel,
} from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';

const ErrSection = (props) => {
  const { className, breakpoint } = props;
  //const err = [];

  return (
    <div className={`${css.container} ${className || ''}`}>
      <Field shouldUpdate>
        {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
          const value = get(props, 'value');
          const moduleType = get(value, 'moduleType');
          const extraProps = { breakpoint };
          const errors = () => {
            switch (moduleType) {
              case EnumModuleType.ResponsiveText: {
                return [];
              }
              case EnumModuleType.ResponsiveSubscription: {
                return [];
              }
              case EnumModuleType.ResponsivePoster: {
                return [];
              }
              case EnumModuleType.ResponsiveContentGrid: {
                const { checkTopSectionDisplayError } =
                  checkResponsiveContentGrid();
                const res = checkTopSectionDisplayError(value, extraProps);
                const errors = get(res, 'errors');
                return errors || [];
              }
              case EnumModuleType.ResponsiveContentTab: {
                return [];
              }
              case EnumModuleType.ResponsiveContentCarousel: {
                const { checkTopSectionDisplayError } =
                  checkResponsiveContentCarousel();
                const res = checkTopSectionDisplayError(value, extraProps);
                const errors = get(res, 'errors');
                return errors || [];
              }
              case EnumModuleType.ResponsiveImageCarousel: {
                return [];
              }
              case EnumModuleType.ResponsiveProductTab: {
                return [];
              }
              case EnumModuleType.ResponsiveProductCarousel: {
                const { checkTopSectionDisplayError } =
                  checkResponsiveProductCarousel();
                const res = checkTopSectionDisplayError(value, extraProps);
                const errors = get(res, 'errors');
                return errors || [];
              }
              case EnumModuleType.ResponsiveProductGrid: {
                const { checkTopSectionDisplayError } =
                  checkResponsiveProductGrid();
                const res = checkTopSectionDisplayError(value, extraProps);
                const errors = get(res, 'errors');
                return errors || [];
              }
              case EnumModuleType.ResponsivePosterTab: {
                return [];
              }
              default: {
                return [];
              }
            }
          };
          //const isAuto = getFieldValue(autoPlayCheckbox);
          //console.log('props', props, meta);

          return <ErrorDisplay2 err={errors()} hasError />;
        }}
      </Field>
    </div>
  );
};
export default ErrSection;
